// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3SqC1","inputDescription":"styles_inputDescription__mjJSc"};